import { Youtube, Building2, Video, Plug } from 'lucide-react';
import type { PlatformId } from '@utils/types/connections/connection.ts';

interface Props {
  platform: PlatformId;
  className?: string;
}

export default function PlatformIcon({ platform, className }: Props) {
  switch (platform) {
    case 'youtube':
      return <Youtube className={className} aria-hidden="true" />;
    case 'vimeo':
      // lucide-react ships a Vimeo-branded icon as ``Video`` from v0.395+
      // — but the project pins an older version. ``Video`` (camera icon)
      // is the closest unambiguous stand-in and matches the rounded
      // badge look of the other platform tiles.
      return <Video className={className} aria-hidden="true" />;
    case 'ibabs':
      return <Building2 className={className} aria-hidden="true" />;
    default:
      return <Plug className={className} aria-hidden="true" />;
  }
}
